// extracted by mini-css-extract-plugin
module.exports = {"docs":"Docs_docs__1641f","icon":"Docs_icon__11WGq","iconGreen":"Docs_iconGreen__1vodN","button":"Docs_button__25WJQ"};